import Link from "next/link";
import { useCallback, useMemo } from "react";
import { Img } from "@/components/image";
import type { DietListingBannerType } from "@/features/diets/types/diet-listing-banners.type";

type DietListCarouselDefaultProps = {
  strapiUrl: string;
  banner: DietListingBannerType;
};

export const DietListCarouselDefault = ({
  strapiUrl,
  banner,
}: DietListCarouselDefaultProps) => {
  const getImageUrl = useCallback(
    (path: string) => {
      if (path.startsWith("http")) {
        return path;
      }
      return `${strapiUrl}${path}`;
    },
    [strapiUrl],
  );

  const image = useMemo(
    () => (
      <picture>
        <source
          media="(max-width: 767px)"
          srcSet={getImageUrl(banner.imageMobile.url)}
        />
        <Img
          alt={banner.image.name}
          height={banner.image.height}
          src={getImageUrl(banner.image.url)}
          width={banner.image.width}
        />
      </picture>
    ),
    [banner, getImageUrl],
  );

  return <>{banner.url ? <Link href={banner.url}>{image}</Link> : image}</>;
};
